/**
 * Leest wat er in het tariefveld van een traject staat en geeft terug wat er
 * in `PersonaRoutes.Tariff` mag: een eindig getal, of `''` als er niets
 * bruikbaars staat.
 *
 * WAAROM DIT BESTAAT: het instellingenscherm deed `parseInt(e.target.value)`
 * en schreef dat ongezien weg. `parseInt('')` is `NaN`, en `NaN` is een
 * getal — dus elke controle op 'is er een tarief?' liet het door en elke som
 * ermee werd `NaN`. Gemeten 2026-09-30: 13 trajecten platformbreed. Zie
 * docs/inbox.md #292. Een leeg veld blijft hier leeg: `''` is in deze
 * codebase de afgesproken vorm voor 'nog geen waarde'.
 *
 * AI-CONTEXT: See docs/pitfalls.md#database-empty-string-is-a-real-stored-value
 *
 * @param {*} value - Waarde uit het invoerveld (string) of al een getal
 * @returns {number|''} Een eindig getal, anders `''`
 */
const parseTariff = (value) => {
    if (value === null || value === undefined) return ''
    if (typeof value === 'string' && value.trim() === '') return ''
    if (typeof value !== 'string' && typeof value !== 'number') return ''

    const number = Number(value)
    return Number.isFinite(number) ? number : ''
}

export default parseTariff
